// extracted by mini-css-extract-plugin
export var container = "styles-module--container--717dd";
export var content = "styles-module--content--ef5a4";
export var logo = "styles-module--logo--71b06";
export var section = "styles-module--section--c5508";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--f81b4";